import { Injectable, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { signOut } from 'aws-amplify/auth';
import * as _ from 'lodash';
import { SessionService } from './session.service';
import { MatDialog } from '@angular/material/dialog';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  public loggedUser: any

    constructor(
      private router: Router,
      private sessionService: SessionService,
      private dialog: MatDialog
    ) {
  }

  /**Auth Related Methods - starts */
  public getToken(): string {
    return sessionStorage.getItem('token') || '';
  }

  public isLoggedIn() {

    const user = this.sessionService.getUserAttributes();
    const userName = this.sessionService.getUsername();
    // check for token expiry, will fail for no token or invalid token
    const token = sessionStorage.getItem('token');

    if(user != null && userName) {
      return true;
    } else {
      return false;
    }
  }
  /**Auth Related Methods - ends */

  // private inactivityTimeout!: ReturnType<typeof setTimeout>;

  // startInactivityTimer() {
  //   this.inactivityTimeout = setTimeout(() => {
  //     this.logoutAndRedirect();
  //   }, 20 * 60 * 1000);
  // }

  // resetInactivityTimer() {
  //   clearTimeout(this.inactivityTimeout);
  //   this.startInactivityTimer();
  // }

  logoutAndRedirect() {
    signOut();
    
    sessionStorage.clear();
    this.dialog.closeAll();
    this.sessionService.setUser(null);
    this.sessionService.setUsername(null);
    this.sessionService.setMainUsername(null);
    this.sessionService.setLoginTime(null);

    window.location.href = "/login";
  }

}
